import ResortPass from '#components/icons/ResortPass';
import Typography from '#components/typography/Typography';
import styles from './ResortPassHint.module.scss';

const ResortPassHint = ({ text }) => {
  return (
    <Typography fontSize="small">
      <span className={styles.icon}>
        <ResortPass size={24} />
      </span>
      <span
        className="tw-align-middle"
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </Typography>
  );
};

export default ResortPassHint;
